import { baseApi } from './baseApi';

export const adminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Auth endpoints
    login: builder.mutation({
      query: (body) => ({
        url: 'auth/login',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      // Note: transformResponse receives the data after baseQuery processes it
      // The baseQuery already extracts response.data, so response here IS the data
      transformResponse: (response) => {
        // response is already the data object from baseQuery transformation
        return response;
      },
    }),

    // Staff/Admin endpoints
    getStaffAdmins: builder.query({
      query: (query = '') => ({
        url: query ? `staff/list?${query}` : 'staff/list',
        method: 'GET',
      }),
      providesTags: ['Admins'],
    }),

    getAdmin: builder.query({
      query: (staffId) => ({
        url: `staff/get/${staffId}`,
        method: 'GET',
      }),
      providesTags: (result, error, staffId) => [{ type: 'Admin', id: staffId }],
    }),

    addStaffAdmin: builder.mutation({
      query: (body) => ({
        url: 'staff/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Admins'],
    }),

    updateAdmin: builder.mutation({
      query: (body) => ({
        url: 'staff/edit',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Admin', 'Admins'],
    }),

    updateProfile: builder.mutation({
      query: (body) => ({
        url: 'staff/edit-profile',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Admin'],
    }),

    updatePassword: builder.mutation({
      query: (body) => ({
        url: 'staff/edit-profile',
        method: 'PUT',
        body,
      }),
    }),

    deleteAdmin: builder.mutation({
      query: (adminId) => ({
        url: `staff/delete/${adminId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admins'],
    }),

    // Password management
    forgotPassword: builder.mutation({
      query: (body) => ({
        url: 'staff/forgot-password',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    resetPassword: builder.mutation({
      query: (body) => ({
        url: 'staff/reset-password',
        method: 'PUT',
        body,
      }),
    }),

    // Verification
    getUserVerify: builder.mutation({
      query: (body) => ({
        url: 'staff/verify-admin-password',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    verifyRole: builder.query({
      query: (roleId) => ({
        url: `auth/verifyRole?id=${roleId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useGetStaffAdminsQuery,
  useGetAdminQuery,
  useAddStaffAdminMutation,
  useUpdateAdminMutation,
  useUpdateProfileMutation,
  useUpdatePasswordMutation,
  useDeleteAdminMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useGetUserVerifyMutation,
  useVerifyRoleQuery,
} = adminApi;

